import { render } from "./Checkbox.vue?vue&type=template&id=af4e9bc2&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=af4e9bc2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-af4e9bc2"

export default script